import styled from "styled-components"

const ModalBackground = styled.div`
    display: visible; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 100; /* Sit on top */
    padding: ${props => ((props.isFullScreenOnMobile || props.isFullScreen) ? `0rem` : props.padding ? props.padding : "8.6rem 0rem")}; 
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgba(0,0,0,0.4)'}; 
    @media only screen and (min-width: 700px) {
        padding: ${props => ((props.isFullScreen) ? `0rem` : "12rem 0rem")}; 
    }
    ${props => props.centerContent ? "display: flex; justify-content: center; align-items: center;" : ""}
    
`

const ModalContainer = styled.div`
    user-select: none;
    background-color: #FEFEFE;
    margin: auto;
    border-radius: .2rem;
    box-shadow: 0 .1rem .4rem  rgba(0,0,0, .2);
    /* border: 1px solid #888; */
    width: ${props => ((props.isFullScreenOnMobile || props.isFullScreen) ? `100%` : "90%")};
    display: flex;
    flex-direction: column;
    ${props => props.style}

    @media only screen and (min-width: 700px) {
        width: ${props => ((props.isFullScreen) ? `100%` : "40%")};
    }
`

const ModalContainerMedium = styled.div`
    background-color: #FEFEFE;
    margin: auto;
    width: ${props => ((props.isFullScreenOnMobile || props.isFullScreen) ? `100%` : "95%")};
    height: ${props => ((props.isFullScreenOnMobile || props.isFullScreen) ? ` 100%` : "auto")};
    display: flex;
    flex-direction: column;
    border-radius: .2rem;
    ${props => props.style}

    @media only screen and (min-width: 700px) {
        width: ${props => ((props.isFullScreen) ? `100%` : "60%")};
        height: ${props => ((props.isFullScreen) ? ` 100%` : "auto")};
    }
`


const CloseButton = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    font-size: 18px;
    color: #777;
    /* background-color: #777 */

    :hover, :focus {
        text-decoration: none;
        cursor: pointer;
    }

    margin: .4rem .8rem 0rem 0rem;
    @media (max-width: 767px) {
        font-size: 1.8rem; 
    }
`

const ModalTitle = styled.div`
    margin: 0;
    padding: 2rem 2rem 1rem 1.8rem;
    font-size: 1.6rem;
    font-weight: 600;
    ${props => props.titleStyle}
`

const ModalHeader = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
`

const ModalMessage = styled.div`
    padding: 1rem 2rem 2rem 1.8rem;
    overflow-y: auto;
    font-size: 1.2rem;
    ${props => props.messageStyle}
`

const ModalFooter = styled.div`
    padding: 1rem;
    display: flex;
    justify-content: center;
    border-top: solid thin #CCC;
`

export {
    ModalContainer,
    ModalContainerMedium,
    ModalBackground,
    ModalHeader,
    ModalTitle,
    CloseButton,
    ModalMessage,
    ModalFooter
}